import { useEffect, useState } from "react";
import styles from "./index.module.less";
import {
  useChangeHiddenStatusMutation,
  useGetScriptHiddenStatusMutation,
} from "features/script/api";
import { Switch, notification } from "components/common";
import { useSelector } from "react-redux";

const ScriptInfoSection = ({ details, previewMode }) => {
  const [isPageHidden, setIsPageHidden] = useState(false);
  const user = useSelector((state) => state.app.user?.info);

  const [checkPageHiddenStatus, { isLoading: isLoadingCheckHiddenPages }] =
    useGetScriptHiddenStatusMutation();
  const [changeHiddenStatus, { isLoading: resetLoading }] =
    useChangeHiddenStatusMutation();

  useEffect(() => {
    if (details?.editor_template_id) {
      checkPageHiddenStatus({
        editor_template_id: details?.editor_template_id,
      }).then((res) => {
        setIsPageHidden(res?.data?.data?.is_hidden);
      });
    }
  }, [details]);

  const convertDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = { month: "long", day: "2-digit", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const renderSpecialties = () => {
    if (!details?.speciality?.length) {
      return <div className={styles.emptyState}>No specialties defined</div>;
    }

    return details.speciality.map((specialty, index) => (
      <div key={index} className={styles.specialtyItem}>
        {specialty}
      </div>
    ));
  };

  const renderTopics = () => {
    if (!details?.topics?.length) {
      return <div className={styles.emptyState}>No topics defined</div>;
    }

    return details.topics.map((topic, index) => (
      <div key={index} className={styles.specialtyItem}>
        {topic}
      </div>
    ));
  };

  return (
    <div id={`Page Details`} className={styles.scriptDetailsCard}>
      <div className={styles.cardHeader}>
        <div className={styles.specialtiesSection}>
          <div className={styles.specialtiesTitle}>Specialties</div>
          <div className={styles.specialtiesList}>{details?.primarySpeciality}</div>
        </div>

        <div className={styles.pageIdSection}>
          <div className={styles.pageIdTitle}>Page ID:</div>
          <div>{details?.page_id}</div>
        </div>

        <div className={styles.topicsSection}>
          <div className={styles.topicsTitle}>Topics</div>
          <div className={styles.topicsList}>{renderTopics()}</div>
        </div>

        {!previewMode && (
          <div className={styles.metadataSection}>
            <div className={styles.modifiedSection}>
              <div className={styles.modifiedTitle}>Modified:</div>
              <div>
                {details?.updated_at && convertDate(details?.updated_at)}
              </div>
            </div>
            <div className={styles.hidePageSection}>
              <div className={styles.hidePageTitle}>Hide Page:</div>
              <div className={styles.hidePageSwitch}>
                <Switch
                  onChange={async () => {
                    await changeHiddenStatus({
                      editor_template_id: details.editor_template_id,
                      is_hidden: !isPageHidden,
                      // user_code: user?._id,
                    })
                      .then(() => {
                        notification.success({
                          message: "Page successfully marked hidden.",
                        });
                        setIsPageHidden(!isPageHidden);
                      })
                      .catch((e) => {
                        notification.error({
                          message: e?.message,
                        });
                      });
                  }}
                  loading={resetLoading}
                  value={isPageHidden}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScriptInfoSection;
